'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Toolbar.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/**
 * ToolbarItemGroup component for aligning multiple subcomponent in the toolbar
 */
var ToolbarItemGroup = function ToolbarItemGroup(_ref) {
  var align = _ref.align,
    className = _ref.className,
    children = _ref.children,
    other = _objectWithoutProperties(_ref, ['align', 'className', 'children']);
  var baseToolbarItmGroupClass = (0, _classnames2.default)({
    'c-toolbar__left': align === 'left'
  }, {
    'c-toolbar__center': align === 'center'
  }, {
    'c-toolbar__right': align === 'right'
  }, className);
  return _react2.default.createElement('div', _extends({}, other, {
    className: baseToolbarItmGroupClass
  }), children);
};
ToolbarItemGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Size of the modal*/
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  /**Children of the toolbar on the right*/
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = ToolbarItemGroup;